export default __webpack_public_path__ + "static/media/sbj-geography.9313dabe.svg";